import { _isNotEmpty } from '@/littledash';
import type { SendCoverageGridRow } from '@/model/Agent.model';
import type { FC } from 'react';
import { sendDatasetLabel } from '@/components/Agents/SendValidator/utils/SendDomains';
import SendTallyTable from './SendTallyTable';
import styles from './SendResults.module.scss';

interface SendCoverageGridProps {
  rows: ReadonlyArray<SendCoverageGridRow>;
  testId?: string;
}

/** The server's key for rules that apply to the bundle as a whole rather than to one dataset. */
const BUNDLE_ROW = 'bundle';

/**
 * How the published rules landed for each dataset, as the server counted them, plus the rules that
 * apply to the bundle as a whole. Every cell is the server's number, read as given.
 */
const SendCoverageGrid: FC<SendCoverageGridProps> = ({ rows, testId = 'invivo-send-validator__coverage-grid' }) => {
  if (!_isNotEmpty(rows)) {
    return null;
  }
  return (
    <div className={`${styles.gridScroll} mt3`} data-test-component="SendCoverageGrid" data-testid={testId}>
      <SendTallyTable
        caption="Rules by dataset"
        heading="Dataset"
        cellPrefix="coverage"
        testId="invivo-send-validator__coverage-table"
        rows={rows.map(({ key, tally }) => ({
          key,
          label: key === BUNDLE_ROW ? 'The bundle as a whole' : sendDatasetLabel(key),
          tally,
          element: 'coverage-row',
        }))}
      />
    </div>
  );
};

export default SendCoverageGrid;
